import { createContext, ReactNode } from 'react';
import { useImmerReducer } from 'use-immer';

import {
  accountModalReducer,
  IAccountModalState,
  INITIAL_ACCOUNT_MODAL_STATE,
} from 'account/state/accountModalReducer';

interface IAccountModalProviderProps {
  children: ReactNode;
}

export const AccountModalDispatchContext = createContext(null);
export const AccountModalStateContext = createContext<IAccountModalState>(
  INITIAL_ACCOUNT_MODAL_STATE,
);

// TODO: remove AccountModalProvider. We cannot set a callbackFunction in redux store, and the
// callbackFunction is deeply coupled in many places. We need to refactor
// those places first before we can remove this Provider.
export const AccountModalProvider = ({ children }: IAccountModalProviderProps) => {
  const [state, dispatch] = useImmerReducer(accountModalReducer, INITIAL_ACCOUNT_MODAL_STATE);

  return (
    <AccountModalDispatchContext.Provider value={dispatch}>
      <AccountModalStateContext.Provider value={state}>
        {children}
      </AccountModalStateContext.Provider>
    </AccountModalDispatchContext.Provider>
  );
};
